module.exports = __webpack_public_path__ + "static/index/img/baikal-205.b71b2242.jpg";